import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Overline = ({ children, light = false }) => (
    <p className={`font-mono-brand text-xs uppercase tracking-[0.25em] font-semibold ${light ? "text-[#E85A1D]" : "text-[#E85A1D]"}`}>
        {children}
    </p>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export { EASE };
